import { TCmsBlocks } from '@features/cms/typescript/index';
import styles from '@features/cms/components/pages/CategoryBlocks/CategoryBlocks.styles';
import RenderCmsBlock from '@features/cms/components/RenderCmsBlock';
type PropsType = {
  pageBlocks: TCmsBlocks[];
};
const CategoryBlocks = ({
  pageBlocks
}: PropsType) => <div sx={styles.contentHolder}>
    {pageBlocks.map(block => <RenderCmsBlock key={`${block.type}-${Math.random()}`} block={block} />)}
  </div>;
export default CategoryBlocks;